import React from "react";
import { useLanguage, T } from "@/lib/i18n";

export default function Ticker() {
  const { lang } = useLanguage();
  const items = T.ticker.items[lang];
  const doubled = [...items, ...items];

  return (
    <div className="tickerbar overflow-hidden border-y border-black" data-testid="demands-ticker">
      <div className="flex marquee-track py-3 whitespace-nowrap">
        {doubled.map((it, i) => (
          <div key={i} className="flex items-center gap-6 pr-10">
            <span className="text-sjm-red font-display font-extrabold text-2xl">★</span>
            <span className={`font-display font-bold uppercase tracking-wider text-lg ${lang === "bn" ? "font-bn" : ""}`}>
              {it}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
